/**
 * @property {RequestLogData} detail.requestLogData
 * @property {boolean} detail.isImportant
 */
export default class RequestLogEvent extends CustomEvent {
  /**
   * @param {RequestLogData} requestLogData
   * @param {boolean} isImportant
   */
  constructor({ requestLogData, isImportant = false }) {
    super('request-log', {
      bubbles: true,
      composed: true,
      detail: {
        requestLogData,
        isImportant,
      },
    });
  }
}
